import React, { Component } from 'react';
import Errors from './errors';

export default class Login extends Component {

	constructor(props) {
    super(props);
    this.login = this.login.bind(this);
		this.inputChange = this.inputChange.bind(this);
    this.state = {
			error: false,
			loaded: false
		};
  }

	render() {
		console.log('LOGIN render', this.props);
		if(this.props.data.authorized === true) {

			return (
				<div id="auth">
					<h1>You are logged in.</h1>
					<ul className="options">
						<li><a href="/">To feed</a></li>
					</ul>
				</div>
			);
		}
		return (
			<div id="auth">
	      <form method="post" action="https://atrond.com/services/login" onSubmit={ this.login }>
					<Errors error={ this.state.error } />
	        <label htmlFor="email">Username</label>
	        <input id="email" name="email" type="text" onChange={ this.inputChange } />
	        <label htmlFor="password">Password</label>
	        <input id="password" name="password" type="password" onChange={ this.inputChange } />
		      <button>Log in</button>
	      </form>
			</div>
		);
	}
	inputChange(e) {
		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		this.setState({
			[name]: value
		});
		console.log(value);
	}
  login(e) {
		e.preventDefault();
		console.log('do login', this.state);
		fetch('https://atround.com/services/login.php',
		{
			method: "POST",
			headers: {
    		"Accept": "application/json",
  		},
			credentials: 'include',
			body: JSON.stringify({ email: this.state.email, password: this.state.password })
		})
		.then(response => response.json())
		.then(
			(result) => {
			console.log(result);
			if(result.error) {
				console.log('AUTH ERR', result.error);
				this.setState({
					error: result.error
				})
			} else if(result.data) {
				console.log('AUTH OK', result);
				this.props.onStatusChange(result.data);
				this.setState({
					loaded: false
				});
			}
		},
			// Note: it's important to handle errors here
			// instead of a catch() block so that we don't swallow
			// exceptions from actual bugs in components.
			(error) => {
				console.log(error);
				this.setState({
          loaded: false,
          error
        });
			}
		)
  }
}



// WEBPACK FOOTER //
// ./src/components/login.jsx